// terminPeek.ts — pure Helfer für das Klick-Popover der Dashboard-Termine-Karte
// (Dashboard-Termine-Review SP5, A10): Einladungs-Richtung und reduzierte
// Teilnehmerliste. Bewusst OHNE React/DOM, damit die Logik unter vitest
// (node-Env, nur *.test.ts) testbar bleibt; die Komponente selbst lebt in
// DashTerminPopover.tsx. Alle Daten stammen aus der Graph-Listen-Antwort
// (organizer/attendees sind im List-DTO vorhanden) — kein Zusatz-Fetch.

/** Anzeigename einer Person: Name, sonst Adresse (jeweils getrimmt). */
const personLabel = (p: { name?: string | null; address?: string | null }): string =>
    p.name?.trim() || p.address?.trim() || "";

/**
 * Einladungs-Richtung (A10): Organisator == eigenes Postfach → „Du hast
 * eingeladen"; sonst „Eingeladen von {Name}". Ohne Organisator (oder ohne
 * benennbaren Namen bei fremdem Organisator) → null, die Zeile entfällt.
 * Adress-Vergleich case-insensitive.
 */
export function einladungsRichtung(
    organizer: { name: string; address: string } | null | undefined,
    ownAddress: string,
): string | null {
    if (!organizer) return null;
    const own = ownAddress.trim().toLowerCase();
    if (own.length > 0 && organizer.address?.trim().toLowerCase() === own) {
        return "Du hast eingeladen";
    }
    const name = personLabel(organizer);
    return name.length > 0 ? `Eingeladen von ${name}` : null;
}

/**
 * Teilnehmerliste reduzieren (A10): das eigene Postfach herausnehmen, höchstens
 * `max` Namen zeigen, der Rest als „+N weitere" bündeln. `rest` zählt ALLE über
 * `max` hinausgehenden Teilnehmer (unabhängig von leeren Namen, damit die
 * Zählung mit der Gesamtzahl übereinstimmt). Ist kein eigenes Postfach bekannt
 * (`ownAddress` leer), bleibt die Liste vollständig.
 */
export function reduzierteTeilnehmer(
    attendees:
        | { name: string; address: string; type: string; response: string }[]
        | null
        | undefined,
    ownAddress: string,
    max = 5,
): { namen: string[]; rest: number } {
    const own = ownAddress.trim().toLowerCase();
    const alle = attendees ?? [];
    const ohneSelbst =
        own.length === 0
            ? alle
            : alle.filter((a) => a.address?.trim().toLowerCase() !== own);
    const namen = ohneSelbst
        .slice(0, max)
        .map(personLabel)
        .filter((n) => n.length > 0);
    const rest = ohneSelbst.length - Math.min(max, ohneSelbst.length);
    return { namen, rest };
}
